var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-halflings",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "plus",
    d: "M17,9v2a1,1,0,0,1-1,1H12v4a1,1,0,0,1-1,1H9a1,1,0,0,1-1-1V12H4a1,1,0,0,1-1-1V9A1,1,0,0,1,4,8H8V4A1,1,0,0,1,9,3h2a1,1,0,0,1,1,1V8h4A1,1,0,0,1,17,9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.0c8c5e507000770ff4b165ac8ac8e567.svg";
export { ForwardRef as ReactComponent };